export default __webpack_public_path__ + "static/media/whatsapp.737c3c07.svg";